<template>
  <list-basic
    caption="小さな行動"
    :description="$store.state.habit.smallAction"
    :action="action"
  />
</template>

<script>
import ListBasic from '@/lib/List/Basic/index'

export default {
  components: {
    ListBasic
  },

  methods: {
    action () {
      this.$router.push({ name: 'habit-small-action' })
    }
  }
}
</script>
